'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllMessages = exports.getServerSideContent = exports.getLanguageWithoutRegionCode = exports.getServerSideLocaleData = exports.getPackagesLocaleDataFromWindow = exports.getPackagesLocaleData = exports.setServerSideLocaleData = exports.setPackageLocaleData = exports.shouldLoadLocaleData = exports.getLanguageLabel = exports.mapLocale = undefined;

var _lodash = require('lodash');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

'use strict';
var i18n = {};

var mapLocale = exports.mapLocale = function mapLocale(locale) {
  return (0, _lodash.split)(locale, '_')[0];
};

var getLanguageLabel = exports.getLanguageLabel = function getLanguageLabel(locale) {
  var label = (0, _lodash.toUpper)(mapLocale(locale));
  return label === 'ZH' ? 'CN' : label;
};

var shouldLoadLocaleData = exports.shouldLoadLocaleData = function shouldLoadLocaleData(packageName) {
  return !(i18n && i18n.packages && i18n.packages[packageName]);
};

var setPackageLocaleData = exports.setPackageLocaleData = function setPackageLocaleData(packageName, localeData) {
  (0, _lodash.set)(window, 'i18n.packages[' + packageName + ']', localeData);
  (0, _lodash.set)(i18n, 'packages[' + packageName + ']', localeData);
};

var setServerSideLocaleData = exports.setServerSideLocaleData = function setServerSideLocaleData(localeData) {
  (0, _lodash.set)(window, 'i18n.serverSideContent', localeData);
  (0, _lodash.set)(i18n, 'serverSideContent', localeData);
};

var getPackagesLocaleData = exports.getPackagesLocaleData = function getPackagesLocaleData() {
  return (0, _lodash.get)(i18n, 'packages');
};

var getPackagesLocaleDataFromWindow = exports.getPackagesLocaleDataFromWindow = function getPackagesLocaleDataFromWindow() {
  return (0, _lodash.get)(window, 'i18n.packages');
};

var getServerSideLocaleData = exports.getServerSideLocaleData = function getServerSideLocaleData() {
  return (0, _lodash.get)(i18n, 'serverSideContent');
};

var getLanguageWithoutRegionCode = exports.getLanguageWithoutRegionCode = function getLanguageWithoutRegionCode() {
  return window.locale.toLowerCase().split(/[_-]+/)[0];
};

var getServerSideContent = exports.getServerSideContent = function getServerSideContent() {
  var locale = window.locale ? getLanguageWithoutRegionCode() : 'en';
  var serverSideContent = getServerSideLocaleData();
  var result = {};
  if (serverSideContent) {
    serverSideContent.forEach(function (content) {
      result[content.id] = (0, _lodash.get)(content, locale);
    });
  }

  (0, _lodash.set)(window, 'resultServer', result);
  (0, _lodash.set)(window, 'localeVal', locale);
  (0, _lodash.set)(window, 'serverSideContentVal', serverSideContent);
  return result;
};

var getAllMessages = exports.getAllMessages = function getAllMessages() {
  // Temp solution until all packages using propera-fw updating the version
  var i18nPacks = getPackagesLocaleDataFromWindow();
  if (i18nPacks) {
    var result = _lodash.merge.apply(undefined, _toConsumableArray([{}].concat(Object.values(i18nPacks))).concat([getServerSideContent()]));
    (0, _lodash.set)(window, 'allMsgs', result);
    return result;
  }

  return {};
};